module.exports = __webpack_public_path__ + "static/logo-4de973c622ba2bd17d9cf3143e7daf61.png";